import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllTenants } from '../../../services/api';
import './Tenants.css';

// Interface para o Tenant
interface Tenant {
  id: string;
  name: string;
  email: string;
  credits: number;
  active: boolean;
  createdAt: string;
  parentId?: string | null;
  parent?: {
    id: string;
    name: string;
  } | null;
}

const Tenants: React.FC = () => {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Carregar os tenants da API
  useEffect(() => {
    fetchTenants();
  }, []);

  const fetchTenants = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await getAllTenants();
      
      if (response.success) {
        setTenants(response.data || []);
      } else {
        setError(response.error || 'Erro ao carregar clientes');
      }
    } catch (error) {
      setError('Erro ao conectar com o servidor');
      console.error('Erro ao buscar tenants:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  };

  return (
    <div className="tenants-container">
      <div className="tenants-header">
        <h2>Gerenciamento de Clientes</h2>
        <Link to="/admin/tenants/new" className="btn-add-tenant">
          Adicionar Cliente
        </Link>
      </div>

      {loading && <div className="loading">Carregando clientes...</div>}
      
      {error && <div className="error-message">{error}</div>}

      {!loading && tenants.length === 0 && (
        <div className="no-tenants">
          Nenhum cliente cadastrado. Clique em "Adicionar Cliente" para criar o primeiro.
        </div>
      )}

      {!loading && tenants.length > 0 && (
        <div className="tenants-table-container">
          <table className="tenants-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Email</th>
                <th>Cliente Pai</th>
                <th className="credits-col">Créditos</th>
                <th>Status</th>
                <th>Data Cadastro</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {tenants.map(tenant => (
                <tr key={tenant.id} className={!tenant.active ? 'inactive-tenant' : ''}>
                  <td>{tenant.name}</td>
                  <td>{tenant.email}</td>
                  <td>
                    {tenant.parent ? (
                      <Link to={`/admin/tenants/${tenant.parent.id}`}>
                        {tenant.parent.name}
                      </Link>
                    ) : (
                      <span className="no-parent">Cliente Principal</span>
                    )}
                  </td>
                  <td className={`credits-col ${tenant.credits < 1 ? 'low-credits' : ''}`}>
                    {tenant.credits.toFixed(2)}
                  </td>
                  <td>
                    <span className={`status-badge ${tenant.active ? 'active' : 'inactive'}`}>
                      {tenant.active ? 'Ativo' : 'Inativo'}
                    </span>
                  </td>
                  <td>{formatDate(tenant.createdAt)}</td>
                  <td className="actions-cell">
                    <div className="action-links">
                      <Link to={`/admin/tenants/${tenant.id}`} className="btn-view" title="Ver detalhes">
                        Detalhes
                      </Link>
                      <Link to={`/admin/tenants/${tenant.id}/subtenants`} className="btn-subtenants" title="Subclientes vinculados">
                        Subclientes
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Tenants; 